import { render } from "./AddAndUpdateAssetInGalleryModal.vue?vue&type=template&id=07b2eea8&scoped=true&ts=true&lang=pug"
import script from "./AddAndUpdateAssetInGalleryModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddAndUpdateAssetInGalleryModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddAndUpdateAssetInGalleryModal.vue?vue&type=style&index=0&id=07b2eea8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b2eea8"]])

export default __exports__